const INTIAL_STATE = {
  // employeeList: [],
  dailySellout: [],
  dailySelloutCA: [],
  monthlySellout: [],
  monthlySelloutCA: [],
  selloutFacility: [],
  selloutWholesaler: []
};

export default (state = INTIAL_STATE, action) => {
  switch (action.type) {
    case "DAILY_SELLOUT":
      return Object.assign({}, state, { dailySellout: action.payload });
    case "DAILY_SELLOUT_CA":
      return Object.assign({}, state, { dailySelloutCA: action.payload });
    case "MONTHLY_SELLOUT":
      return Object.assign({}, state, { monthlySellout: action.payload });
    case "MONTHLY_SELLOUT_CA":
      return Object.assign({}, state, { monthlySelloutCA: action.payload });
    case "SELLOUT_FACILITY":
      return Object.assign({}, state, { selloutFacility: action.payload });
    case "SELLOUT_WHOLESALER":
      return Object.assign({}, state, { selloutWholesaler: action.payload });
    default:
      return state;
  }
};
